<template>
  <div class="container" v-wechat-title="$route.meta.title">
    <div class="topTitle carTitle">
      <img class="back" @click="$router.go(-1)" src="../assets/pingzi/back.png" alt="" />
      <div class="title"></div>
      <div v-if="!buyBlockShow" class="option" @click="isManageMode = !isManageMode">
        {{ isManageMode ? "管理" : "完成" }}
      </div>
    </div>
    <div class="cartTop" v-if="isType==1">
        <div class="customerName">客户名称：{{customerName}}</div>
        <div class="companyName">
          <span>{{CompanyName}}</span>
        </div>
    </div>
    <!-- 购物车非空状态 -->
    <van-list class="van-clearfix goodsBox">
      <div v-for="(it, idx) in list" :key="idx">
        <div class="warehouseName">{{ it.WarehouseName }}</div>
        <ul class="list">
          <buy-car-item
            v-for="(item, index) in it.list"
            :item="item"
            :key="index"
            :enableCheck="true"
            :wareHouseType="wareHouseType"
            @jia="jia.apply(this, $event)"
            @jian="jian.apply(this, $event)"
            @inputFocus="inputFocus.apply(this, $event)"
            @handleSelect="handleSelect.apply(this, $event)"
          ></buy-car-item>
        </ul>
      </div>
    </van-list>
    <!-- 购物车空状态 -->
    <div ref="buyBlock" class="buyBlock" v-if="buyBlockShow">
      <div class="buyBlockTop">
        <img src="../assets/icon/gouwuche.png" />
        <span class="buyBlockTxt">购物车是空的</span>
      </div>
    </div>

    <!-- 底部结算  -->
    <div class="footer flexSpBte" style="z-index:2;">
      <div class="checkTapBox" @click="allSelectTap">
        <img
          class="checkimg"
          :src="allSelect ? require('../assets/newicon/xuanzhong.png') : require('../assets/newicon/weixuanzhong.png')"
          alt=""
        />
        <span class="">全选</span>
        <div class="goodsTotal">
          共计
          <span class="goodsNumber">{{ selectArrLength }}</span>
          件
        </div>
      </div>
      <div class="buybtn">
        <div class="hj">
          <span class="">合计：</span>
          <span class="goodsNumber">
            <span class="finalAmount"> ￥{{ finalAmount.toFixed(2) }} </span>
          </span>
        </div>
        <div
          class="sumbtn"
          :class="{ cansumbtn: selectArrLength > 0, deleclass: !isManageMode && selectArrLength > 0 }"
          @click="jiesuan"
          v-if="isManageMode"
        >
          <span class="">结算</span>
        </div>
        <div
          class="sumbtn"
          :class="{ cansumbtn: selectArrLength > 0, deleclass: !isManageMode && selectArrLength > 0 }"
          @click="deleteItems"
          v-if="!isManageMode"
        >
          <span class="">删除</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "../utils/util";
import buyCarItem from "../components/buyCarItem";
import axiosp from "../utils/axiosp";
import { type } from "os";
import BuyCarStore from "../store/buycar";
import FirmOrderStore from "../store/FirmOrder";
import IndexStore from "../store/Index";
import GroupByList from "../store/Base/GroupByList";
import { Toast,Dialog } from "vant";
export default {
  components: { buyCarItem },
  data() {
    return {
      //购物车Store，通过Vue添加响应式
      buyCarState: BuyCarStore.state,
      //是否为管理模式
      isManageMode: true,
      //购物车数据
      //list: BuyCarStore.state.list,
      warehouseList: IndexStore.state.warehouseList,
      wareHouseType:0,
      isType:2,
      customerName:'',
      CompanyName:IndexStore.state.CompanyName,
      warehouseText:IndexStore.state.warehouseText
    };
  },
  computed: {
    //全选状态
    allSelect: () => BuyCarStore.state.isSelectAll,
    //数量合计
    selectArrLength: () => BuyCarStore.getSelectedLength(),
    list:()=>{
      let groupByList = new GroupByList({ list: BuyCarStore.state.list });
      let groupByResult = groupByList.groupBy("WarehouseId");
      groupByResult.forEach((it) => {
        let warehouse = IndexStore.state.warehouseList.find((warehouse) => warehouse.value == it.name) || {};
        it.WarehouseId = warehouse.value || 0;
        it.WarehouseName = warehouse.text || "";
      });
      return groupByResult
    },
    //金额合计
    finalAmount: () => BuyCarStore.getSelectedAmount(),
    //是否显示占位图
    buyBlockShow() {
      return this.list.length === 0;
    },
  },
  created() {
    this.isType = util.getStoObj('urlQuery').IsTypr
    if(this.isType==1){
      this.customerName = sessionStorage.getItem("CustomerName");
    }

    // let groupByList = new GroupByList({ list: BuyCarStore.state.list });
    // let groupByResult = groupByList.groupBy("WarehouseId");

    // groupByResult.forEach((it) => {
    //   let warehouse = IndexStore.state.warehouseList.find((warehouse) => warehouse.value == it.name) || {};

    //   it.WarehouseId = warehouse.value || 0;
    //   it.WarehouseName = warehouse.text || "";
    // });
    // this.list = groupByResult;
    this.wareHouseType = IndexStore.state.wareHouseType
    console.log('BuyCarStore',BuyCarStore.state.list)
  },
  methods: {
    newCartList() {
      let cartList = BuyCarStore.state.list;
      let warehouseList = IndexStore.state.warehouseList;
      let newCartList = [];

      cartList.forEach((item) => {
        //10
        warehouseList.forEach((item2) => {
          //3
          if (item.WarehouseId == item2.value) {
            //10
            let data = {
              WarehouseId: item.WarehouseId,
              WarehouseName: item2.text,
              list: [],
            };
            newCartList.push(data);
          }
        });
      });
      return newCartList;
    },
    jiesuan() {
      if (!this.selectArrLength) {
        return;
      }
      let _WarehouseId = -1;
      let warehouseIdArr = [];
      let list = BuyCarStore.getSelected();
      for (let i = 0; i < list.length; i++) {
        if (list[i].WarehouseId != _WarehouseId) {
          warehouseIdArr.push(list[i].WarehouseId);
        }
        _WarehouseId = list[i].WarehouseId;
      }
      if (warehouseIdArr.length > 1) {
        Toast("存在不同仓库的商品不允许同时生成结算单.请选一个仓库的商品单独结算");
        return;
      }
      FirmOrderStore.setForm("buycar");
      FirmOrderStore.updateList(list);

      this.$router.push(`/firmOrder`);
    },
    //改变全选状态
    allSelectTap: () => BuyCarStore.selectedAll(!BuyCarStore.state.isSelectAll),
    //改变选择砖头盖
    handleSelect: (item) => BuyCarStore.selected(item, !item.check),
    //删除选中
    deleteItems: () => {
      Dialog.confirm({
        title: '',
        message: '确定删除选中产品吗？',
      }).then(() => {
          return BuyCarStore.deleteSelectedItems()
      }).catch(() => {
          // on cancel
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/activityBills.scss";
@import "../styles/buyCar.scss";
.container{
  margin-bottom: 1rem;
  .list{
    margin-bottom: 10px;
  }
}
.goodsSearch{
  background: #fff;
  padding: 10px;
  font-size: 12px;
  span{
    background:url(../assets/icon/sousuo.png) no-repeat 5px center #f6f6f6;
    background-size:auto 85%; 
    display: block;
    padding:6px 6px 6px 30px;
    border-radius: 5px;
    color: #999;
  }
}
.cartTop{
  font-size:0.28rem;
  background: #fff;
  border-radius: 0.22rem;
  padding:10px;
  margin: 10px;
  .customerName{
    margin-bottom: 5px;
  }
  .companyName{
    display: flex;
    justify-content: space-between;
  }
}

.carTitle {
  .title {
    width: 100%;
  }
}

.totalCont {
  .info {
    font-size: 0.24rem;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }
  .it {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    box-sizing: border-box;
    height: 0.7rem;
    span {
      &:nth-child(1) {
        font-size: 0.24rem;
        color: rgba(28, 28, 28, 1);
      }
      &:nth-child(2) {
        font-size: 0.26rem;
        color: rgba(255, 90, 46, 1);
      }
    }
  }
}
.back {
  z-index: 999;
}
.warehouseName {
  font-size: 14px;
}
</style>

<style lang="scss">
.van-radio {
  .van-icon.van-icon-success {
    background: #fff;
  }
}
.van-radio.van-radio--disabled .van-icon.van-icon-success {
  background: #d8d8d8;
}
</style>
